import React from 'react'
import IconQuote from 'svg/icons/quote.svg'

import './quoteCard.scss'

const QuoteCard = ({ theme, noquote, icon, text, author, company }) => {
	return (
		<blockquote
			className={`quoteCard
				${theme !== undefined && `quoteCard-${theme}`}
				${noquote !== undefined && `quoteCard-no-quote`}
				`}
		>
			{icon ? (
				<span className="icon-container">
					<IconQuote />
				</span>
			) : (
				<></>
			)}
			<p className="quoteCard_text">{text}</p>
			<cite className="quoteCard_author">
				<div>
					<strong>{author}</strong>
					<span>{company}</span>
				</div>
			</cite>
		</blockquote>
	)
}

export default QuoteCard
